import script from "./login-methods-section.vue?vue&type=script&setup=true&lang=js"
export * from "./login-methods-section.vue?vue&type=script&setup=true&lang=js"

import "./login-methods-section.vue?vue&type=style&index=0&id=0a546227&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a546227"]])

export default __exports__